import { api } from 'shared/api'

import { AdsSchemas } from './schema'

export const AdsApi = {
  getAdAccountsList: api.account.createGet({
    url: '/ads/getFacebookMarketingMessagesAdAccounts',
    schemas: AdsSchemas.getAdAccountsList,
  }),
  createFbmmCampaign: api.account.createPost({
    url: '/ads/createFacebookMarketingMessagesCampaign',
    schemas: AdsSchemas.createFbmmCampaign,
  }),
  getFbmmCampaignsList: api.account.createGet({
    url: '/ads/getFacebookMarketingMessagesCampaignsList',
    schemas: AdsSchemas.getFbmmCampaignsList,
  }),
  getFbmmEstimations: api.account.createGet({
    url: '/ads/getFacebookMarketingMessagesEstimations',
    schemas: AdsSchemas.getFbmmEstimations,
  }),
  deleteFbmmCampaign: api.account.createPost({
    url: '/ads/deleteFacebookMarketingMessagesCampaign',
    schemas: AdsSchemas.deleteFbmmCampaign,
  }),

  // Custom Audiences Action for IG
  fetchAdAccountsForIg: api.account.createGet({
    url: '/ads/ig/getCustomAudienceAdAccounts',
    schemas: AdsSchemas.fetchAdAccountsForIg,
  }),
  fetchCustomAudiencesForIg: api.account.createGet({
    url: '/ads/ig/getListCustomAudiences',
    schemas: AdsSchemas.fetchCustomAudiencesForIg,
  }),
  fetchCustomAudienceUserActionNamesForIg: api.account.createGet({
    url: '/ads/ig/getCustomAudienceUserActionNames',
    schemas: AdsSchemas.fetchCustomAudienceUserActionNamesForIg,
  }),
  getIsOptedIn: api.account.createGet({
    url: '/settings/isOptedIn',
    schemas: AdsSchemas.getIsOptedIn,
  }),
}
